"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mountIsland_1 = require("../../mountIsland");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
var Pagination_1 = __importDefault(require("@mui/material/Pagination"));
var Select_1 = __importDefault(require("@mui/material/Select"));
var MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
var Lang_js_1 = require("../../Lang.js");
var NAVY = '#1c1c3c';
var ENDPOINT = '/app/admin/subscriptions/renewals';
var SEARCH_DEBOUNCE_MS = 300;
var PER_PAGE_OPTIONS = [10, 25, 50, 100];
var STATUS_CONFIG = {
    paid: { label: 'Paid', color: '#92400e', bg: 'rgba(245,158,11,0.12)' },
    acknowledged: { label: 'Acknowledged', color: '#1a6e1e', bg: 'rgba(25,148,32,0.10)' },
};
// Column order must match the grid template below. `key: null` = not sortable.
var COLUMNS = [
    { label: 'Member', key: 'member' },
    { label: 'Email', key: 'email' },
    { label: 'Product', key: 'product' },
    { label: 'Amount', key: 'amount' },
    { label: 'Paid', key: 'paid' },
    { label: 'Status', key: 'status' },
    { label: 'Actions', key: null },
];
function formatAmount(amount, currency) {
    var code = (currency || 'usd').toUpperCase();
    try {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: code }).format(amount);
    }
    catch (e) {
        return "$".concat((amount !== null && amount !== void 0 ? amount : 0).toFixed(2), " ").concat(code);
    }
}
var StatusBadge = function (_a) {
    var _b;
    var status = _a.status;
    var cfg = (_b = STATUS_CONFIG[status]) !== null && _b !== void 0 ? _b : STATUS_CONFIG.paid;
    return (react_1.default.createElement(Box_1.default, { sx: {
            display: 'inline-flex', alignItems: 'center', gap: '5px',
            px: '10px', py: '3px', borderRadius: '12px',
            backgroundColor: cfg.bg, color: cfg.color,
            fontSize: '12px', fontWeight: 700, whiteSpace: 'nowrap',
        } },
        react_1.default.createElement(Box_1.default, { sx: { width: '6px', height: '6px', borderRadius: '50%', backgroundColor: cfg.color, flexShrink: 0 } }),
        (0, Lang_js_1.__)(cfg.label)));
};
var StatCard = function (_a) {
    var label = _a.label, value = _a.value, sub = _a.sub;
    return (react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
            p: '18px 22px', borderRadius: 2, backgroundColor: '#fff',
            boxShadow: '0 1px 3px rgba(0,0,0,0.07)', flex: 1,
        } },
        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '12px', fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px', mb: 0.5 } }, label),
        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '28px', fontWeight: 700, color: NAVY, lineHeight: 1 } }, value),
        sub && react_1.default.createElement(Typography_1.default, { sx: { mt: 0.5, fontSize: '12px', color: '#aaa' } }, sub)));
};
var SubscriptionRenewalList = function (_a) {
    var _b, _c;
    var initial = _a.initial;
    var _d = (0, react_1.useState)(initial.renewals), renewals = _d[0], setRenewals = _d[1];
    var _f = (0, react_1.useState)(initial.pagination), pagination = _f[0], setPagination = _f[1];
    var _g = (0, react_1.useState)(initial.stats), stats = _g[0], setStats = _g[1];
    var _h = (0, react_1.useState)(''), search = _h[0], setSearch = _h[1];
    var _j = (0, react_1.useState)(''), debouncedSearch = _j[0], setDebouncedSearch = _j[1];
    var _k = (0, react_1.useState)('all'), statusFilter = _k[0], setStatusFilter = _k[1];
    var _l = (0, react_1.useState)((_b = initial.sort) !== null && _b !== void 0 ? _b : { key: null, dir: 'desc' }), sort = _l[0], setSort = _l[1];
    var _m = (0, react_1.useState)(initial.pagination.per_page), perPage = _m[0], setPerPage = _m[1];
    var _o = (0, react_1.useState)(initial.pagination.page), page = _o[0], setPage = _o[1];
    var _p = (0, react_1.useState)(false), loading = _p[0], setLoading = _p[1];
    var _q = (0, react_1.useState)(null), error = _q[0], setError = _q[1];
    var hydrated = (0, react_1.useRef)(false);
    // Debounce the search box. A new term always returns to page 1; batching both
    // state updates keeps it to a single refetch.
    (0, react_1.useEffect)(function () {
        if (!hydrated.current)
            return;
        var timer = setTimeout(function () {
            setDebouncedSearch(search);
            setPage(1);
        }, SEARCH_DEBOUNCE_MS);
        return function () { return clearTimeout(timer); };
    }, [search]);
    // Search, filter and paging all resolve server-side. The first render is already
    // painted from the server-rendered bootstrap, so it costs no request.
    (0, react_1.useEffect)(function () {
        if (!hydrated.current) {
            hydrated.current = true;
            return;
        }
        var cancelled = false;
        var params = new URLSearchParams({ page: String(page), per_page: String(perPage) });
        if (debouncedSearch)
            params.set('search', debouncedSearch);
        if (statusFilter !== 'all')
            params.set('status', statusFilter);
        if (sort.key) {
            params.set('sort', sort.key);
            params.set('dir', sort.dir);
        }
        setLoading(true);
        setError(null);
        fetch("".concat(ENDPOINT, "?").concat(params.toString()), {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
        })
            .then(function (res) {
            if (!res.ok)
                throw new Error("HTTP ".concat(res.status));
            return res.json();
        })
            .then(function (body) {
            if (cancelled)
                return;
            setRenewals(body.renewals || []);
            setPagination(body.pagination);
            setStats(body.stats);
        })
            .catch(function (e) {
            if (cancelled)
                return;
            console.warn('SubscriptionRenewalList: fetch failed', e);
            setError((0, Lang_js_1.__)('Could not load renewals. Please try again.'));
        })
            .finally(function () {
            if (!cancelled)
                setLoading(false);
        });
        // A filter changed while this request was in flight — drop its response so a
        // slow earlier request cannot overwrite a faster later one.
        return function () { cancelled = true; };
    }, [debouncedSearch, statusFilter, sort, page, perPage]);
    var filterOptions = [
        { value: 'all', label: (0, Lang_js_1.__)('All') },
        { value: 'paid', label: (0, Lang_js_1.__)('Paid') },
        { value: 'acknowledged', label: (0, Lang_js_1.__)('Acknowledged') },
    ];
    var selectStatus = function (value) {
        setStatusFilter(value);
        setPage(1);
    };
    // First click on a column sorts ascending; clicking the active column flips it.
    var toggleSort = function (key) {
        setSort(function (prev) { return ({ key: key, dir: prev.key === key && prev.dir === 'asc' ? 'desc' : 'asc' }); });
        setPage(1);
    };
    var selectPerPage = function (value) {
        setPerPage(value);
        setPage(1);
    };
    return (react_1.default.createElement(Box_1.default, { sx: { p: 2, maxWidth: '1400px', mx: 'auto', backgroundColor: '#f5f6f8', minHeight: '80vh' } },
        react_1.default.createElement(Box_1.default, { sx: { mb: 3, display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 } },
            react_1.default.createElement(Box_1.default, null,
                react_1.default.createElement(Typography_1.default, { component: "a", href: "/app/admin", sx: { display: 'block', mb: 1.5, fontSize: '13px', fontWeight: 600, color: NAVY, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } } },
                    "\u2190 ",
                    (0, Lang_js_1.__)('Admin Dashboard')),
                react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h1", sx: { mt: 0.5, fontSize: '24px', fontWeight: 700, color: NAVY } }, (0, Lang_js_1.__)('Subscription Renewals')))),
        react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' } },
            react_1.default.createElement(StatCard, { label: (0, Lang_js_1.__)('Paid'), value: stats.total_paid, sub: (0, Lang_js_1.__)('Awaiting processing') }),
            react_1.default.createElement(StatCard, { label: (0, Lang_js_1.__)('Acknowledged'), value: stats.total_acknowledged, sub: (0, Lang_js_1.__)('Completed') }),
            react_1.default.createElement(StatCard, { label: (0, Lang_js_1.__)('Amount Awaiting'), value: "$".concat(((_c = stats.amount_awaiting) !== null && _c !== void 0 ? _c : 0).toFixed(2)), sub: (0, Lang_js_1.__)('Paid, not yet processed') })),
        react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
                p: '14px 18px', mb: 2, borderRadius: 2,
                backgroundColor: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.07)',
                display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap',
            } },
            react_1.default.createElement(TextField_1.default, { placeholder: (0, Lang_js_1.__)('Search by member, email, product, amount, or payment intent…'), value: search, onChange: function (e) { return setSearch(e.target.value); }, size: "small", sx: { flex: 1, minWidth: '240px' }, InputProps: {
                    startAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "start" },
                        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '16px', color: '#aaa' } }, "\u2315"))),
                } }),
            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 1, flexWrap: 'wrap' } }, filterOptions.map(function (opt) { return (react_1.default.createElement(Box_1.default, { key: opt.value, onClick: function () { return selectStatus(opt.value); }, sx: {
                    px: '14px', py: '5px', borderRadius: '20px', cursor: 'pointer',
                    fontSize: '13px', fontWeight: 600,
                    backgroundColor: statusFilter === opt.value ? NAVY : 'transparent',
                    color: statusFilter === opt.value ? '#fff' : '#555',
                    border: "1px solid ".concat(statusFilter === opt.value ? NAVY : '#ddd'),
                    transition: 'all 0.15s ease',
                    '&:hover': { borderColor: NAVY, color: statusFilter === opt.value ? '#fff' : NAVY },
                } }, opt.label)); })),
            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#888', ml: 'auto', whiteSpace: 'nowrap' } },
                pagination.total,
                " ",
                pagination.total === 1 ? (0, Lang_js_1.__)('result') : (0, Lang_js_1.__)('results'))),
        react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
                borderRadius: 2, backgroundColor: '#fff',
                boxShadow: '0 1px 3px rgba(0,0,0,0.07)',
                overflow: 'hidden',
                opacity: loading ? 0.55 : 1,
                transition: 'opacity 0.15s ease',
            } },
            react_1.default.createElement(Box_1.default, { sx: {
                    display: 'grid',
                    gridTemplateColumns: '2fr 2fr 1.5fr 1fr 1.4fr 1.2fr 100px',
                    px: '18px', py: '10px',
                    backgroundColor: '#f8f9fa',
                    borderBottom: '1px solid #e8e8e8',
                } }, COLUMNS.map(function (col) {
                var active = col.key !== null && sort.key === col.key;
                return (react_1.default.createElement(Typography_1.default, { key: col.label, onClick: col.key ? function () { return toggleSort(col.key); } : undefined, sx: {
                        display: 'flex', alignItems: 'center', gap: '4px',
                        fontSize: '11px', fontWeight: 700, letterSpacing: '0.5px',
                        textTransform: 'uppercase',
                        color: active ? NAVY : '#888',
                        cursor: col.key ? 'pointer' : 'default',
                        userSelect: 'none',
                        '&:hover': col.key ? { color: NAVY } : undefined,
                    } },
                    (0, Lang_js_1.__)(col.label),
                    col.key && (react_1.default.createElement(Box_1.default, { component: "span", sx: { fontSize: '9px', opacity: active ? 1 : 0.35 } }, active && sort.dir === 'desc' ? '▼' : '▲'))));
            })),
            error ? (react_1.default.createElement(Box_1.default, { sx: { p: '32px', textAlign: 'center' } },
                react_1.default.createElement(Typography_1.default, { sx: { color: '#b91c1c', fontSize: '14px' } }, error))) : renewals.length === 0 ? (react_1.default.createElement(Box_1.default, { sx: { p: '32px', textAlign: 'center' } },
                react_1.default.createElement(Typography_1.default, { sx: { color: '#aaa', fontSize: '14px' } }, (0, Lang_js_1.__)('No renewals match your filters.')))) : (renewals.map(function (o, idx) { return (react_1.default.createElement(Box_1.default, { key: o.id, sx: {
                    display: 'grid',
                    gridTemplateColumns: '2fr 2fr 1.5fr 1fr 1.4fr 1.2fr 100px',
                    px: '18px', py: '14px',
                    borderBottom: idx < renewals.length - 1 ? '1px solid #f0f0f0' : 'none',
                    alignItems: 'center',
                    '&:hover': { backgroundColor: '#fafbfc' },
                } },
                react_1.default.createElement(Box_1.default, null,
                    react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', fontWeight: 600, color: NAVY } }, o.member_name || '—'),
                    react_1.default.createElement(Typography_1.default, { sx: { fontSize: '12px', color: '#888', fontFamily: 'monospace', mt: '2px' } }, o.memberid || '—'),
                    react_1.default.createElement(Typography_1.default, { sx: { fontSize: '12px', color: '#888', mt: '2px' } }, o.user_login || '—')),
                react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#555', wordBreak: 'break-all' } }, o.email || '—'),
                react_1.default.createElement(Box_1.default, null,
                    react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#333', fontWeight: 600 } }, o.display_type || o.product_label || o.product_type),
                    o.description && (react_1.default.createElement(Typography_1.default, { sx: { fontSize: '11px', color: '#999', mt: '2px' } }, o.description)),
                    o.can_apply_gift && (react_1.default.createElement(Box_1.default, { sx: {
                            display: 'inline-block', mt: '4px',
                            px: '8px', py: '2px', borderRadius: '10px',
                            backgroundColor: 'rgba(245,158,11,0.14)', color: '#92400e',
                            fontSize: '11px', fontWeight: 700,
                        } }, (0, Lang_js_1.__)('Not applied')))),
                react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', fontWeight: 600, color: '#333' } }, formatAmount(o.amount, o.currency)),
                react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#555' } }, o.paid_at || '—'),
                react_1.default.createElement(Box_1.default, null,
                    react_1.default.createElement(StatusBadge, { status: o.status })),
                react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 1 } },
                    react_1.default.createElement(Box_1.default, { component: "a", href: "/app/admin/subscriptions/renewals/".concat(o.id), sx: {
                            px: '10px', py: '5px', borderRadius: '4px',
                            backgroundColor: NAVY, color: '#fff',
                            fontSize: '12px', fontWeight: 600, textDecoration: 'none',
                            whiteSpace: 'nowrap',
                            '&:hover': { backgroundColor: '#2a2a4c', textDecoration: 'none', color: '#fff' },
                        } }, (0, Lang_js_1.__)('View'))))); }))),
        react_1.default.createElement(Box_1.default, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3, mt: 3, flexWrap: 'wrap' } },
            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', alignItems: 'center', gap: 1 } },
                react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#888' } }, (0, Lang_js_1.__)('Per page')),
                react_1.default.createElement(Select_1.default, { value: perPage, onChange: function (e) { return selectPerPage(Number(e.target.value)); }, disabled: loading, size: "small", sx: { fontSize: '13px', backgroundColor: '#fff' } }, PER_PAGE_OPTIONS.map(function (n) { return (react_1.default.createElement(MenuItem_1.default, { key: n, value: n, sx: { fontSize: '13px' } }, n)); }))),
            pagination.total_pages > 1 && (react_1.default.createElement(Pagination_1.default, { count: pagination.total_pages, page: pagination.page, onChange: function (_e, value) { return setPage(value); }, disabled: loading, shape: "rounded", color: "primary" })))));
};
var renewalListEl = document.getElementById('msia-admin-subscription-renewals-container');
if (renewalListEl) {
    var bootstrapEl = document.getElementById('msia-admin-subscription-renewals-bootstrap');
    var fallback = {
        renewals: [],
        pagination: { page: 1, per_page: 25, total: 0, total_pages: 1 },
        sort: { key: null, dir: 'desc' },
        stats: { total_paid: 0, total_acknowledged: 0, amount_awaiting: 0 },
    };
    var initial = fallback;
    try {
        initial = (bootstrapEl === null || bootstrapEl === void 0 ? void 0 : bootstrapEl.textContent) ? JSON.parse(bootstrapEl.textContent) : fallback;
    }
    catch (e) {
        console.warn('SubscriptionRenewalList: parse error', e);
    }
    (0, mountIsland_1.mountIsland)(renewalListEl, react_1.default.createElement(SubscriptionRenewalList, { initial: initial }));
}
exports.default = SubscriptionRenewalList;
